@if (!credential) {
  <div fxLayout="row">
    <mat-icon class="error">cancel</mat-icon
    ><span class="ml-1 bold">never issued</span>
  </div>
} @else if (credential.status === 'PreIssue') {
  <div fxLayout="row">
    <mat-icon class="warning">warning</mat-icon
    ><span class="ml-1 bold"
      >{{ credential.credentialName }} scenario in progress</span
    >
  </div>
} @else {
  <div class="snapshot-card">
    <mat-icon class="snapshot-icon">verified_user</mat-icon>
    <div class="snapshot-body">
      @if (showName) {
        <div class="snapshot-title">
          {{ credential.credentialName }}
        </div>
      }
      @if (credential.credentialNumber) {
        <div class="snapshot-sub">
          {{ credential.credentialNumber }}
        </div>
      }
      @if (credential.credentialStartDate || credential.credentialEndDate) {
        <div class="snapshot-sub">
          @if (credential.credentialStartDate) {
            <span>{{
              credential.credentialStartDate | localDate: 'MMM DD, YYYY'
            }}</span>
          }
          @if (credential.credentialStartDate && credential.credentialEndDate) {
            <span> - </span>
          }
          @if (credential.credentialEndDate) {
            <span>{{
              credential.credentialEndDate | localDate: 'MMM DD, YYYY'
            }}</span>
          }
        </div>
      }
      @if (credential.isRenewalAvailable) {
        <div class="snapshot-sub">
          <span class="bold">Renewal Available</span>
        </div>
      }
      @if (credential.isReinstatementAvailable) {
        <div class="snapshot-sub">
          <span class="bold">Reinstatement Available</span>
        </div>
      }
    </div>
    <span class="snapshot-status">
      <svg width="10" height="10" class="snapshot-status-dot">
        <circle
          class="status-dot"
          [ngClass]="
            CredentialStatusLabelColor[
              credential.customCredentialStatusDefinition.color
            ]
          "
          cx="5"
          cy="5"
          r="4"
          stroke-width="0"
        />
      </svg>
      {{ credential.customCredentialStatusDefinition.label }}
    </span>
  </div>
  <ng-content></ng-content>
}
